import AddTimerIntervalsComponent from '../AddIntervals'
import BellTypeDropDown from '../BellTypeDropDown'
import { GenericTimerSettingsGridContainer } from '../styledComponents'

export default function FixedTimerSettings({
  timerSettings,
  setTimerSettings,
  handleChange,
  intervals,
  setIntervals,
  intervalDurationLimits,
}) {
  return (
    <GenericTimerSettingsGridContainer spacing={2} container>
      <BellTypeDropDown bellType={timerSettings?.bellType} handleChange={handleChange} />
      <AddTimerIntervalsComponent
        intervals={intervals}
        setIntervals={setIntervals}
        intervalDurationLimits={intervalDurationLimits}
      />
    </GenericTimerSettingsGridContainer>
  )
}
